import { ButtonTypeName } from "../button/button.component";

export enum DialogState {
    Confirm = 1,
    Cancel,
    Decline
}

export type DialogButtonResult = {
    state: DialogState,
    value?: unknown
};

export interface DialogResolution<TData = unknown> {
    state: DialogState;
    value?: unknown;
    data?: TData;
    role?: string;
}

export interface DialogButton {
    text: string;
    state: DialogState;
    type?: ButtonTypeName | undefined;
    value?: unknown;
    focus?: boolean;
}

export enum DialogSize {
    Wide = 'Wide',
    Half = 'Half',
    Regular = 'Regular'
}

export interface ConfirmationDialogOptions {
    title: string;
    text: string;
    buttons: DialogButton[];
    size?: DialogSize;
    closeOnOutsideClick?: boolean;
}
